import React from "react";
import { Modal, Button } from "react-bootstrap";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignal,
  faThumbsUp,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import "../../Pages/HomePage.css";

const SignalModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered className="showNormalFont">
      <Modal.Header>
        <div className="d-flex w-100">
          <FontAwesomeIcon
            className="ms-auto"
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={handleClose}
            icon={faXmark}
          />
        </div>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column justify-content-between align-items-center text-center">
        <span className="text-center">
          <AiOutlineInfoCircle className="info-Icon" />
        </span>
        <h2 className="signal-icon-info-title" id="signal-icon-info-title">
          Connection status
        </h2>
        <div className="d-flex flex-column justify-content-between align-items-center">
          <span className="online mt-3">
            <FontAwesomeIcon icon={faSignal} />
          </span>
          <span className="signal-icon-info-text">
            Tunnel is online, system OK.
          </span>
          <span className="offline-may-work mt-3">
            <FontAwesomeIcon icon={faSignal} />
          </span>
          <span className="signal-icon-info-text">
            Tunnel is offline, some features may not work.
          </span>
          <span className="offline mt-3">
            <FontAwesomeIcon icon={faSignal} />
          </span>
          <span className="signal-icon-info-text">
            Device is offline, check network connection.
          </span>
          <Button
            variant="primary"
            className="mt-3 mb-2 signal-info-btn"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faThumbsUp} /> Got it!
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SignalModal;
